export class SerializeUtil {

  public static deserialize<T extends {}>(obj: T, data: { [key: string]: any }): { [key: string]: any } {
    return Object.assign(obj, data);
  }

  public static deserializeList<T>(obj: T[], data: { [key: string]: any }): T[] {
    return Object.assign(obj, data);
  }
}

export class AuthToken {
  constructor(public access: string = '', public refresh: string = '', public id: number = 0, public first_name: string = '', public last_name: string = '', public groups: string[] = []) {
  }

  public static deserialize(obj: { [key: string]: any }): AuthToken {
    return new AuthToken(obj['access'], obj['refresh'], obj['id'], obj['first_name'], obj['last_name'], obj['groups']);
  }
}

export interface LoaderState {
  show: boolean;
}
